import React, { useState, useEffect } from 'react';
import MobileNavlink from './mobileNav';

const Headers = () => {
  const [activeLink, setActiveLink] = useState('');
  const [isScrolled, setIsScrolled] = useState(false); // Track scroll state
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Set the active link based on the hash in the URL
  useEffect(() => {
    setActiveLink(window.location.hash);

    const handleHashChange = () => {
      setActiveLink(window.location.hash);
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // Track the scroll position and update header style
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) { // You can adjust the scroll position trigger here
        setIsScrolled(true); // Change state if scrolled
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the scroll event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Toggle mobile menu visibility
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      id="header"
      className={`fixed-top ${isScrolled ? 'header-scrolled' : ''}`} // Apply 'header-scrolled' class on scroll
    >
      <div className="container d-flex align-items-center">
        <a href="index.html" className="text-white nav-link fs-3 fw-bold">
          MM<span className="text-primary">CS</span>
        </a>

        <a href="index.html" className="logo me-auto">
          <img src="assets/img/logo.png" alt="" className="img-fluid" />
        </a>

        <nav id="navbar" className="navbar">
          <ul>
            <li>
              <a
                href="#product"
                className={`nav-link scrollto ${activeLink === '#product' ? 'active' : ''}`}
              >
                Product
              </a>
            </li>
            <li>
              <a
                href="#casestudies"
                className={`nav-link scrollto ${activeLink === '#casestudies' ? 'active' : ''}`}
              >
                Case Studies
              </a>
            </li>
            <li>
              <a
                href="#testimonial"
                className={`nav-link scrollto ${activeLink === '#testimonial' ? 'active' : ''}`}
              >
                Testimonial
              </a>
            </li>
            <li>
              <a
                href="#clients"
                className={`nav-link scrollto ${activeLink === '#clients' ? 'active' : ''}`}
              >
                Clients
              </a>
            </li>
            <li>
              <a
                href="#about"
                className={`nav-link scrollto ${activeLink === '#about' ? 'active' : ''}`}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className={`nav-link scrollto ${activeLink === '#contact' ? 'active' : ''}`}
              >
                Contact
              </a>
            </li>
            <li>
              <a className="getstarted scrollto" href="#product">
                Get Start
              </a>
            </li>
          </ul>
          <div>
            <i
              className={`mobile-nav-toggle d-xl-none bi ${isMobileMenuOpen ? 'bi-x' : 'bi-list'}`} // Toggle between bi-x and bi-list
              onClick={toggleMobileMenu}
            ></i>
          </div>
        </nav>
      </div>
      {isMobileMenuOpen ? <MobileNavlink setIsMobileMenuOpen={setIsMobileMenuOpen} /> : ''}
    </header>
  );
};

export default Headers;
